import { defineMessages } from 'react-intl';

const messages = defineMessages({
  heroHeading: {
    id: 'junts_hero_heading',
    defaultMessage: 'Hero Heading',
  },
  title: {
    id: 'title',
    defaultMessage: 'Title',
  },
});

export const heroHeadingSchema = (props) => {
  return {
    title: props.intl.formatMessage(messages.heroHeading),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['title'],
      },
    ],

    properties: {
      title: {
        title: props.intl.formatMessage(messages.title),
      },
    },
    required: ['title'],
  };
};
